<template>
  <div>

    <b-row>
      <b-col
        md="12"
        sm="12"
        lg="12"
      >

        <!-- search input -->
        <b-row v-if="serviceTypes.length > 0">
          <b-col
            sm="12"
            md="6"
            lg="6"
          >
            <!-- service type select -->
            <b-form-group>
              <v-select
                v-model="serviceTypeId"
                :options="serviceTypes"
                placeholder="اختر نوع المعاملة"
                :reduce="val => val.id"
                :get-option-label="option => option.name_ar"
              />

            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="6"
            lg="6"
          >
            <!-- search input -->
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input
                v-model="searchword"
                placeholder="Search..."
                @input="handleSearch"
              />
            </b-input-group>
          </b-col>
        </b-row>
        <!-- tree -->
        <div
          v-if="load"
          class="text-center my-4"
        >
          <b-spinner
            type="grow"
            label="جاري التحميل..."
          />
        </div>
        <v-tree
          v-else
          ref="tree"
          :can-delete-root="true"
          :data="filteredTreeData"
          :draggable="true"
          :tpl="tpl"
          :halfcheck="false"
          :multiple="false"
        />

        <template #code>
          {{ codeSearch }}
        </template>
      </b-col>

      <!-- The right column for actions is removed -->
    </b-row>
  </div>
</template>

<script>
import { VTree } from 'vue-tree-halower'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BFormInput, BInputGroupPrepend, BInputGroup, BRow,
  BCol, BFormCheckbox, BFormGroup,
  BCard, BBadge, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
import { codeSearch } from './codesearsh'

export default {
  components: {
    VTree,
    BSpinner,
    BFormCheckbox,
    BFormGroup,
    BCardCode,
    BBadge,
    vSelect,
    BInputGroupPrepend,
    BInputGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
  },
  watch: {
    serviceTypeId(newVal) {
      this.$store.dispatch('myServices/listServicesTree', { service_type_id: newVal })
      if (!this.servicesTree?.length) {
      }
    },
    searchword(newVal) {
      this.$store.dispatch('myServices/listServicesTree', { searchword: newVal })
    },
    selected_service_id(newVal) {
      // this.$store.dispatch("myServices/getServiceActions",newVal);
      // Only pass selected services up
      // this.$emit('selection-changed', { service_id: newVal, action_ids: [] });
      // Instead, just emit all selected services to parent
      console.log(this.selectedServiceIds, this.serviceTypeId)

      this.$emit('selection-changed', { selectedServiceIds: this.selectedServiceIds, service_type_id: this.serviceTypeId })
    },
    // Comment out everything for selectedActions
    // selectedActions() {
    //   this.$emit('selection-changed', { service_id: this.selected_service_id, selectedServiceIds : this.selectedServiceIds, action_ids: this.selectedActions });
    // }
  },
  computed: {
    ...mapGetters({
      load: 'myServices/load',
      servicesTree: 'myServices/servicesTree',
      serviceActions: 'myServices/serviceActions',
      loadServiceActions: 'myServices/loadServiceActions',
      serviceTypes: 'serviceTypes/serviceTypes',
    }),
    treeData() {
      const data = this.transformTreeData(this.servicesTree)
      // if (!this.serviceTypeId)
       return data
      // return this.filterTreeByServiceType(data, this.serviceTypeId)
    },
    filteredTreeData() {
      if (!this.searchword.trim()) {
        return this.treeData
      }
      return this.filterTreeData(this.treeData, this.searchword.toLowerCase())
    },
  },
  data() {
    return {
      codeSearch,
      serviceTypeId: null,
      searchword: '',
      selectedServiceIds: [], // Only service selection is required
      // selectedActions: [], // // Remove/disable actions
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    transformTreeData(data) {
      if (!data || !Array.isArray(data)) return []

      return data.map(item => ({
        id: item.id,
        title: item.name,
        service_type: item.service_type,
        service_type_id: item.service_type_id ?? item.service_type?.id,
        parent_id: item.parent_id,
        expanded: true, // Start collapsed for better search visibility
        children: this.transformTreeData(item.children || []),
      }))
    },

    nodeMatchesServiceType(node, serviceTypeId, inheritedTypeId = null) {
      const rawType = node.service_type?.id
        ?? node.service_type_id
        ?? (typeof node.service_type === 'number' ? node.service_type : null)
        ?? inheritedTypeId
      return rawType != null && Number(rawType) === Number(serviceTypeId)
    },

    filterTreeByServiceType(nodes, serviceTypeId, inheritedTypeId = null) {
      if (!Array.isArray(nodes) || !serviceTypeId) return nodes || []

      return nodes
        .map(node => {
          const effectiveTypeId = node.service_type?.id
            ?? node.service_type_id
            ?? (typeof node.service_type === 'number' ? node.service_type : null)
            ?? inheritedTypeId
          const matches = this.nodeMatchesServiceType(node, serviceTypeId, inheritedTypeId)

          if (matches) {
            return {
              ...node,
              children: node.children || [],
            }
          }

          const children = this.filterTreeByServiceType(node.children || [], serviceTypeId, effectiveTypeId)
          if (children.length > 0) {
            return { ...node, children }
          }

          return null
        })
        .filter(Boolean)
    },

    filterTreeData(nodes, searchTerm) {
      if (!nodes || !nodes.length) return []

      return nodes
        .map(node => {
          const matches = node.title.toLowerCase().includes(searchTerm)
          const children = this.filterTreeData(node.children, searchTerm)
          const childMatches = children.length > 0

          // If this node matches or has children that match, include it
          if (matches || childMatches) {
            return {
              ...node,
              title: this.highlightSearchTerm(node.title, searchTerm),
              expanded: true, // Expand matching nodes for visibility
              children,
            }
          }
          return null
        })
        .filter(node => node !== null)
    },

    highlightSearchTerm(title, searchTerm) {
      if (!searchTerm) return title

      const regex = new RegExp(`(${this.escapeRegex(searchTerm)})`, 'gi')
      return title.replace(regex, '<mark>$1</mark>')
    },

    escapeRegex(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    },

    handleSearch() {
      // Debounce search to improve performance
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        // Force re-render by updating a reactive property
        this.$forceUpdate()
      }, 300)
    },

    init() {
      // this.$store.dispatch("myServices/listServicesTree")
      this.$store.dispatch('serviceTypes/fetchServiceTypes',{is_active:1})
    },

    selectNode(node) {
      this.selected_service_id = node.id
    },

    collectAllChildrenIds(node) {
      let ids = [node.id]
      if (node.children) {
        node.children.forEach(child => {
          ids = ids.concat(this.collectAllChildrenIds(child))
        })
      }
      return ids
    },
    removeAllChildrenIds(node, arr) {
      let ids = [node.id]
      if (node.children) {
        node.children.forEach(child => {
          ids = ids.concat(this.collectAllChildrenIds(child))
        })
      }
      return arr.filter(id => !ids.includes(id))
    },
    toggleServiceSelect(node) {
      const allIds = this.collectAllChildrenIds(node)
      const isChecked = this.selectedServiceIds.includes(node.id)
      if (isChecked) {
        // Unselect parent and all children
        this.selectedServiceIds = this.removeAllChildrenIds(node, this.selectedServiceIds)
      } else {
        // Select parent and all children
        this.selectedServiceIds = Array.from(new Set([...this.selectedServiceIds, ...allIds]))
      }
      this.$emit('selection-changed', { selectedServiceIds: this.selectedServiceIds, service_type_id: this.serviceTypeId })
    },

    tpl(...args) {
      const { 0: node } = args
      const isChecked = this.selectedServiceIds.includes(node.id)
      return (
        <span class="d-flex align-items-center">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={() => this.toggleServiceSelect(node)}
            class="mr-1"
          />
          <span class="node-title" domPropsInnerHTML={node.title}></span>
        </span>
      )
    },

    async asyncLoad(node) {
      const { checked = false } = node
      this.$set(node, 'loading', true)
      const pro = new Promise(resolve => {
        setTimeout(resolve, 2000, ['async node1', 'async node2'])
      })
      this.$refs.tree.addNodes(node, await pro)
      this.$set(node, 'loading', false)
      if (checked) {
        this.$refs.tree.childCheckedHandle(node, checked)
      }
    },
  },
}
</script>

<style scoped>
.node-title {
  cursor: pointer;
  padding: 2px 5px;
  border-radius: 3px;
}

.node-title:hover {
  background-color: #f0f0f0;
}

.node-selected {
  background-color: #007bff;
  color: white;
}

.tree-expand {
  cursor: pointer;
  margin: 0 5px;
  font-weight: bold;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
  border-radius: 3px;
}

.btn-async, .btn-delete {
  background: none;
  font-size: 12px;
  padding: 2px 6px;
}

/* Style for the radio button */
input[type="radio"] {
  cursor: pointer;
}

/* Style for search highlights */
:deep(mark) {
  background-color: yellow;
  padding: 0;
}
::v-deep .code-toggler {
    display: none !important;
}
</style>
